import { render, staticRenderFns } from "./FaqTypesPage.vue?vue&type=template&id=64235d6b&scoped=true"
import script from "./FaqTypesPage.vue?vue&type=script&lang=js"
export * from "./FaqTypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64235d6b",
  null
  
)

export default component.exports